module.exports = __webpack_public_path__ + "static/media/bg-pattern-how-we-work-desktop.4abb7464.svg";